<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Visa Expired Visa Type Wise Report</h3>
        <div class="text-xs-right">
          <export-summary-report-button model="visa-expired-visa-type-wise" :export-date="range"
                                        :export-country="filter_countries"
                                        v-if="$oauth.checkIfHasPermission(['export visa-expired-visa-type-wise-summary-report'])"/>
          <refresh-button :click-function="updateByVisaExpiredVisaTypeWise"></refresh-button>
        </div>
      </v-flex>
      <v-flex xs12>

        <v-card>
          <v-layout class="py-1 mx-2" row wrap>

          </v-layout>

          <v-divider/>
          <v-card-text class="pa-0">
            <v-simple-table
                class="elevation-0 pb-6"
                v-if="$oauth.checkIfHasPermission(['read visa-expired-visa-type-wise-summary-report'])"
            >
              <thead>
              <!--              <v-progress-linear-->
              <!--                  :active="progressLinearLoading"-->
              <!--                  :indeterminate="progressLinearLoading"-->
              <!--                  absolute-->
              <!--                  bottom-->
              <!--                  color="primary"-->
              <!--              ></v-progress-linear>-->
              <v-overlay :value="progressLinearLoading">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
              </v-overlay>
              <tr>
                <th class="text-center">S.N</th>
                <th class="text-left">Visa Types</th>
                <th class="text-left">No. of visa_expired</th>
              </tr>
              </thead>
              <tbody v-if="visa_expired_country_wise_data !== []">
              <tr v-for="(item,i) in visa_expired_country_wise_data">
                <td class="text-center">{{ Object.keys(visa_expired_country_wise_data).indexOf(i) + 1 }}</td>
                <td>{{ i.replaceAll('-', ' ').toUpperCase() }}</td>
                <td>{{ item[0]['total_visa_expired'] }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-center" colspan="2">Total</td>
                <td class="text-center">{{ total_total_visa_expired }}</td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td><h3 class="text-center">No record found</h3></td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportSummaryReportButton from "../../components/ExportSummaryReportButton";
import ExportButton from "../../components/ExportButton";
import Http from "axios";
import {VERSIONED_API_URL} from "../../config/config";
import RefreshButton from "@/components/RefreshButton";

const REVENUE_SUMMARY_REPORT_URL = `${VERSIONED_API_URL}/summary-report/visa-expired-visa-type-wise`;

export default {
  name: "VisaExpiredCountryWise",
  data() {
    return {
      visa_expired_country_wise_data: [],
      range: {},
      filter_countries: [],
      total_total_visa_expired: 0,
    };
  },
  components: {RefreshButton, CustomDateRangePicker, IssuedVisaFooter, ExportSummaryReportButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "ArrivalDepartureReport/reportLoading",
      countries: "CountryList/all",
    }),
  },
  methods: {
    ...mapActions({
      fetchCountries: "CountryList/fetchAllCountries"
    }),
    updateByVisaExpiredVisaTypeWise() {
      let params = {};
      this.progressLinearLoading = true;
      if (Object.keys(this.range).length > 0)
        params.date_range = this.range;
      if (this.filter_countries)
        params.country = this.filter_countries;

      Http.get(REVENUE_SUMMARY_REPORT_URL, {
        params: params
      })
          .then((res) => {
            this.total_total_visa_expired = 0;
            this.visa_expired_country_wise_data = res.data.data;
            for (const [key, value] of Object.entries(this.visa_expired_country_wise_data)) {
              console.log(value)
              this.total_total_visa_expired += value[0]['total_visa_expired']
            }
            this.progressLinearLoading = false;
          })
          .catch(() => {
            this.$store.commit('Notification/showError', 'Something went wrong');
            this.progressLinearLoading = false;
          });
    }


  },
  mounted() {
    this.fetchCountries();
    this.progressLinearLoading = true;
    Http.get(REVENUE_SUMMARY_REPORT_URL)
        .then((res) => {
          this.total_total_visa_expired = 0;
          this.visa_expired_country_wise_data = res.data.data;
          for (const [key, value] of Object.entries(this.visa_expired_country_wise_data)) {
            console.log(value)
            this.total_total_visa_expired += value[0]['total_visa_expired']
          }
          this.progressLinearLoading = false;
        })
        .catch(() => {
          this.progressLinearLoading = false;
        });

    this.range = {
      start: new Date().toISOString().substr(0, 10),
      end: new Date().toISOString().substr(0, 10)
    }
  }
}
</script>
